import type { OrderItem, FulfillmentMode } from '../types';

export interface PosItemError {
  seller?: boolean;
  warehouse?: boolean;
}

/**
 * Validate per-item required staff fields.
 * - seller (N.Bán) required in all modes.
 * - warehouse (C.Kho) required only when the column is visible (INSTANT).
 * Returns a map keyed by item id; only items with at least one error are present.
 */
export function validatePosItems(
  items: OrderItem[],
  fulfillmentMode: FulfillmentMode,
): Record<string, PosItemError> {
  const requireWarehouse = fulfillmentMode !== 'PREORDER';
  const errors: Record<string, PosItemError> = {};
  for (const item of items) {
    const e: PosItemError = {};
    if (!item.sellerStaffId) e.seller = true;
    if (requireWarehouse && !item.warehouseStaffId) e.warehouse = true;
    if (e.seller || e.warehouse) errors[item.id] = e;
  }
  return errors;
}
